import "./Surrounding.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationCrosshairs } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as IconHospital } from "../../Assets/svg/hospital.svg";
import { ReactComponent as IconEducation } from "../../Assets/svg/education.svg";
import { ReactComponent as IconShopping } from "../../Assets/svg/shopping.svg";
import surroundingImage from "../../Assets/surrounding map.png";

const Surrounding = () => {
  // const settings = {
  //   dots: true,
  //   arrows: false,
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   lazyload: true,
  // };
  const pointData = {
    poin1: [
      "10 Menit ke RS Bhayangkara",
      "15 Menit ke RS Permata Cibubur",
      "15 Menit ke RS Meilia",
      "15 Menit ke RS Mitra Keluarga",
    ],
    poin2: [
      "5 Menit ke Mazaya Islamic School",
      "5 Menit ke Quantum Inti Indonesia School",
      "5 Menit ke Sekolah Karakter",
      "5 Menit ke Universitas Gunadarma",
      "10 Menit ke Springfield School",
      "15 Menit ke Al-Azhar Syifa",
    ],
    poin3: [
      "10 Menit ke Plaza Cibubur",
      "10 Menit ke Ciputra Mall Cibubur",
      "15 Menit ke Transpark Mall Cibubur",
      "15 Menit ke Cibubur Junction",
    ],
  };
  return (
    <section id="surrounding" className="section-surrounding">
      <div className="container-surrounding">
        <h2 className="title">Surrounding Area</h2>
        <div className="container-image">
          <img
            src={surroundingImage}
            alt="Area Sekitar South Tresor"
            className="image"
          />
        </div>
        <div className="container-fasilitas">
          <div className="point">
            <div className="fasilitas">
              <IconHospital className="icon-fasilitas" />
              <span>Public Facilities</span>
            </div>
            {pointData.poin1.map((item, index) => (
              <div className="loc">
                <FontAwesomeIcon
                  icon={faLocationCrosshairs}
                  className="icon-point"
                />
                <span>{item}</span>
              </div>
            ))}
          </div>

          <div className="point">
            <div className="fasilitas">
              <IconShopping className="icon-fasilitas" />
              <span>Shopping Centers</span>
            </div>
            {pointData.poin3.map((item, index) => (
              <div className="loc">
                <FontAwesomeIcon
                  icon={faLocationCrosshairs}
                  className="icon-loc"
                />
                <span>{item}</span>
              </div>
            ))}
          </div>
          <div className="point">
            <div className="fasilitas">
              <IconEducation className="icon-fasilitas" />
              <span>Education</span>
            </div>
            {pointData.poin2.map((item, index) => (
              <div className="loc">
                <FontAwesomeIcon
                  icon={faLocationCrosshairs}
                  className="icon-point"
                />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Surrounding;
